<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">리뷰</h3>
      </v-toolbar>

      <v-flex xs12 class="mt-2">
        <v-card tile flat class="card-shadow px-3 pt-3 pb-2">
          <v-card-title class="pa-0">
            <v-layout row>
              <v-flex style="flex-grow: 0; flex-shrink: 0;">
                <v-img :src="thumbnailSrc" :aspect-ratio="16/9"
                       width="64px" class="mr-2"
                       style=""></v-img>
              </v-flex>
              <v-flex class="text-xs-left">{{ title }}</v-flex>
            </v-layout>
          </v-card-title>

          <v-card-text class="pb-0">
            <v-rating v-model="rating">
              <template v-slot:item="props">
                <v-img class="d-inline-block"
                       width="48px"
                       :src="require(`@/assets/img/icon-star-${props.isFilled ? '' : 'de'}active.png`)"
                       @click="props.click"></v-img>
              </template>
            </v-rating>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex>
        <v-textarea no-resize
                    rows="10"
                    counter="500"
                    solo flat
                    placeholder="리뷰를 남겨주세요."
                    :rules="rules"
                    v-model="review"
                    class="pa-3"
                    background-color="transparent"></v-textarea>
      </v-flex>

    </v-layout>

    <v-footer fixed style="height: 48px;">
      <v-btn block
             @click="submit"
             color="primary"
             :disabled="!review || !rating"
             :loading="loading"
             style="height: 48px;"
             class="ma-0">리뷰 {{ typeof idx !== 'undefined' ? '수정' : '등록' }}하기</v-btn>
    </v-footer>

    <!-- 임시 스낵바 -->
    <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
      {{ snackbarMessage }}
      <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'ReviewForm',
    props: [ 'idx', 'storeIdx', 'title', 'thumbnail', 'score' ],
    computed: {
      thumbnailSrc () {
        return this.thumbnail ? `${this.$storage}/store/${this.thumbnail}` : require('@/assets/img/thumbnail-default.png');
      },
    },
    data() {
      return {
        scrollY: 0,
        rating: 0,
        review: '',
        loading: false,
        rules: [
          v => !!v || '내용을 입력하세요.',
          v => v.length <= 500 || '500자를 초과할 수 없습니다.',
        ],
        snackbar: false,
        snackbarMessage: '',
        leave: false,
      };
    },
    created () {
      this.rating = this.score;
      if (this.idx) {
        this.selectReview({
          storeIdx: this.storeIdx,
          reviewIdx: this.idx
        }).then(response => {
          this.review = response.data.contents;
        }).catch(err => {
          console.error(err);
          this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
        });
      }
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      snackbar (flag) {
        if (!flag && this.leave) this.$router.go(-1);
      }
    },
    methods: {
      ...mapActions('product', [ 'selectReview', 'createOrUpdateReview' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      submit () {
        this.createOrUpdateReview({
          storeIdx: this.storeIdx,
          contents: this.review,
          reviewScore: this.rating,
        }).then(response => {
          console.log(response);
          this.showSnackbar('리뷰를 남겨주셔서 감사합니다.');
          this.leave = true;
        }).catch(err => {
          console.error(err);
          this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
        });
      },
      showSnackbar (message) {
        this.snackbar = true;
        this.snackbarMessage = message;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }
</style>
